import AnswerValue from "./AnswerValue"

class ChecklistAnswerValue extends AnswerValue {
  isChecked?: boolean

  constructor(input?: any) {
    super(input)
    this.isChecked = input?.isChecked || false
  }
}

export default ChecklistAnswerValue
